module.exports = __webpack_public_path__ + "static/media/eng-popup-step5.99980d27.png";